import { render } from "./WorkManagementTabLayout.vue?vue&type=template&id=43125d0a"
import script from "./WorkManagementTabLayout.vue?vue&type=script&lang=ts"
export * from "./WorkManagementTabLayout.vue?vue&type=script&lang=ts"
script.render = render

export default script